import Vue from 'vue'
import EasyToast from 'vue-easy-toast'
Vue.use(EasyToast)


const toast = {
  success(str) {
    Vue.toast(str, {className: 'et-info'}); // #todo
  },
  info(str) {
    Vue.toast(str, {className: 'et-info'});
  },
  warn(str) {
    Vue.toast(str, {className: 'et-warn'});
  },
  error(str) {
    Vue.toast(str, {className: 'et-alert'});
  },


  // Shortcuts
  warning(str) { this.warn(str) },
  danger(str) { this.error(str) },
}


export default toast



// WEBPACK FOOTER //
// ./src/services/toast.js